/* eslint-disable react/destructuring-assignment,react/prop-types,react/react-in-jsx-scope */
/* eslint-disable prefer-arrow-callback,func-names */
import React, { Component } from 'react';
import _ from 'lodash';
import { Modal, notification } from 'antd';
import {
  SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOADING,
  SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_NOT_LOADED,
  SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_SAVING_GROUP_ERROR,
  SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_SAVED_GROUP,
} from '../../store/spottingGroupDrilldown/spottingGroupDrilldownConstants';
import SpottingGroupKeywordObject from '../../store/models/SpottingGroupKeywordObject';
import TableScroller from '../../views/TableScroller';

export default (bottle) => {
  bottle.factory(
    'SpottingGroupDrilldownContainer',
    function ({ SpottingGroupDrilldownView, spottingGroupDrilldownColumns }) {
      return class SpottingGroupDrilldownContainer extends TableScroller {
        constructor(props) {
          super(props);
          this.state = { scrollY: 0, showNameEdit: false, searchExcludeIDs: [] };
        }

        componentDidMount() {
          this.props.editingWordsReset();
          if (this.isNew) {
            this.props.initNewSpottingGroup();
          } else {
            const name = _.get(this, 'props.match.params.name');
            this.props.setCurrentNameID(atob(name));
          }
          super.componentDidMount();
        }

        get rowSelection() {
          return {
            selectedRowKeys: this.props.termsCheckList,
            onChange: this.props.setTermCheckList,
          };
        }

        get goBack() {
          return () => {
            this.props.history.push('/spotting-groups');
          };
        }

        get canDelete() {
          const { name, currentTermEditedName } = this.props;
          return !this.isNew && (name === currentTermEditedName);
        }

        get goHome() {
          return () => {
            this.props.history.push('/');
          };
        }

        get headline() {
          return this.isNew ? 'New Spotting Group' : `Spotting Group "${_.get(this.props, 'name', '?')}"`;
        }

        get loading() {
          return [
            SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOADING,
            SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_NOT_LOADED,
          ].includes(this.props.editingState);
        }

        get uploadProps() {
          const { addKeywords } = this.props;
          return {
            beforeUpload: () => false,
            showUploadList: false,
            accept: '.csv',
            onChange(info) {
              const reader = new FileReader();
              reader.onload = () => {
                const data = reader.result;
                addKeywords(data.toString()
                  .split(/[\n\r]+/g));
              };
              reader.readAsText(info.file);
            },
          };
        }

        get deleteGroup() {
          return () => {
            Modal.confirm({
              title: 'Delete Group',
              content: `Delete ${this.props.name}?`,
              okText: 'Delete',
              cancelText: 'Cancel',
              onOk: (done) => {
                this.props.destroyGroup();
                // note - not waiting for async.
                this.goBack();
                done();
              },
            });
          };
        }

        get isLoading() {
          return this.props.termState === SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOADING;
        }

        get setSearchTerm() {
          return (searchTerm) => {
            if (searchTerm === this.props.searchTerm) {
              return;
            }
            this.props.setEditingSearchTerm(searchTerm);
            if (searchTerm) {
              const searchExcludeIDs = _(this.props.termsEditing)
                .filter(keyword => !keyword.empty && !keyword.has(searchTerm))
                .map('id')
                .value();
              this.setState({ searchExcludeIDs });
            } else {
              this.setState({ searchExcludeIDs: [] });
            }
          };
        }

        get data() {
          const { termsEditing: terms, searchTerm } = this.props;
          const { searchExcludeIDs } = this.state;
          let data = terms;
          if (searchTerm) {
            data = terms.filter(term => !searchExcludeIDs.includes(term.id));
          }
          return data;
        }

        get save() {
          return () => {
            this.props.saveEdits();
          };
        }

        get canSave() {
          const name = _.trim(_.get(this, 'props.currentTermEditedName'));
          if ((!name) || (!_.get(this, 'props.termsEditing', []).filter(({ keyword }) => keyword).length)) {
            return false; // must have at least one keyword
          }
          if (this.hasBadWords) {
            return false;
          }
          return true;
        }

        get hasBadWords() {
          return _.get(this, 'props.termsEditing', []).reduce((err, word) => err || word.isError, false);
        }

        /**
         * Remove event listener
         */
        componentWillUnmount() {
          this.unmounted = true;
        }

        _alertSaveError() {
          const newName = _.trim(_.get(this, 'props.currentTermEditedName', ''));
          notification.error({
            message: `could not save ${newName}`,
            description: _.get(this, 'props.savingGroupError', 'unknown error'),
          });
        }

        _alertSaved() {
          const newName = _.trim(_.get(this, 'props.currentTermEditedName', ''));
          const name = _.get(this, 'props.name', '');
          const terms = _.get(this, 'props.termsEditing', []);
          const data = SpottingGroupKeywordObject.listToData(terms);
          const goBack = this.goBack;

          let description = `${data.length} terms.`;

          if (this.isNew) {
            description = `created "${newName}" with ${description}`;
          } else if (newName === name) {
            description = `updated "${newName}" with ${description}`;
          } else {
            description = `saved "${name}" as "${newName}" with ${description}`;
          }

          let s = setTimeout(() => {
            goBack();
            s = null;
          }, 2000);

          notification.success({
            message: `saved term "${newName}"`,
            description,
            duration: 2.5,
            placement: 'topLeft',
            onOK() {
              if (s) {
                clearTimeout(s);
              }
              goBack();
            },
          });
        }

        getSnapshotBeforeUpdate(prevProps) {
          const prevGroupState = _.get(prevProps, 'addGroupState');
          const newGroupState = _.get(this, 'props.addGroupState');
          console.log('getSnapshotBeforeUpdate --- comparing ', newGroupState, 'to', prevGroupState);
          if (prevGroupState !== newGroupState) {
            console.log('--- Processing state ', newGroupState);
            switch (newGroupState) {
              case SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_SAVING_GROUP_ERROR:
                this._alertSaveError();
                break;

              case SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_SAVED_GROUP:
                this._alertSaved();
                break;

              default:
                console.log('--- ignoring state ', newGroupState);
            }
          }
          return null;
        }

        get columns() {
          return spottingGroupDrilldownColumns(this.props.updateEditingKeyword);
        }

        get deleteChecked() {
          return () => {
            if (!_.get(this, 'props.termsCheckList.length')) {
              Modal.confirm({
                title: 'Delete Keywords',
                content: 'You must check at least one keyword to delete',
                okText: 'OK',
              });
            } else {
              this.props.deleteCheckedTerms();
            }
          };
        }

        get revert() {
          return () => {
            this.props.editingWordsReset();
            this.props.fetchTerm();
          };
        }

        get isNew() {
          return _.get(this.props, 'newList', false);
        }

        render() {
          return (
            <SpottingGroupDrilldownView
              {...this.props}
              {...this.state}
              tableProps={({})}
              headline={this.headline}
              goBack={this.goBack}
              goHome={this.goHome}
              data={this.data}
              isNew={this.isNew}
              canSave={this.canSave}
              save={this.save}
              selectRow={this.selectRow}
              loading={this.loading}
              isLoading={this.isLoading}
              rowSelection={this.rowSelection}
              deleteGroup={this.deleteGroup}
              canDelete={this.canDelete}
              addTitle={this.addTitle}
              onCloseDrawer={this.onCloseDrawer}
              setSearchTerm={this.setSearchTerm}
              deleteChecked={this.deleteChecked}
              hasBadWords={this.hasBadWords}
              revert={this.revert}
              columns={this.columns}
              uploadProps={this.uploadProps}
            />
          );
        }
      };
    },
  );
};
